import { useBarometerAgentSet } from './events/barometer/useBarometerAgentSet'
import { useBarometerAuctionPause } from './events/barometer/useBarometerAuctionPause'
import { useBarometerAuctionResume } from './events/barometer/useBarometerAuctionResume'
import { useBarometerAuctionTimeChange } from './events/barometer/useBarometerAuctionTimeChange'
import { useBarometerBidDeleted } from './events/barometer/useBarometerBidDeleted'
import { useBarometerBidOnAgent } from './events/barometer/useBarometerBidOnAgent'
import { useBarometerBidOptions } from './events/barometer/useBarometerBidOptions'
import { useBarometerCarEnterHotbid } from './events/barometer/useBarometerCarEnterHotbid'
import { useBarometerCarFinished } from './events/barometer/useBarometerCarFinished'
import { useBarometerCarHotbidReset } from './events/barometer/useBarometerCarHotbidReset'
import { useBarometerCarInPrepare } from './events/barometer/useBarometerCarInPrepare'
import { useBarometerCarNotSold } from './events/barometer/useBarometerCarNotSold'
import { useBarometerCarReserved } from './events/barometer/useBarometerCarReserved'
import { useBarometerCarSold } from './events/barometer/useBarometerCarSold'
import { useBarometerItemPublish } from './events/barometer/useBarometerItemPublish'
import { useBarometerItemReserveRelease } from './events/barometer/useBarometerItemReserveRelease'
import { useBarometerItemWithdrawOrDelete } from './events/barometer/useBarometerItemWithdrawOrDelete'
import { useBarometerUserBid } from './events/barometer/useBarometerUserBid'

export const BAROMETER_SOCKET_CALLBACK = 'barometer-car-update'

export function useBarometerSocket() {
  const { userBid } = useBarometerUserBid()
  const { auctionPause } = useBarometerAuctionPause()
  const { auctionResume } = useBarometerAuctionResume()
  const { itemPublish } = useBarometerItemPublish()
  const { itemWithdrawOrDelete } = useBarometerItemWithdrawOrDelete()
  const { bidOptions } = useBarometerBidOptions()
  const { bidDeleted } = useBarometerBidDeleted()
  const { carEnterHotbid } = useBarometerCarEnterHotbid()
  const { carInPrepare } = useBarometerCarInPrepare()
  const { carNotSold } = useBarometerCarNotSold()
  const { carSold } = useBarometerCarSold()
  const { carReserved } = useBarometerCarReserved()
  const { agentSet } = useBarometerAgentSet()
  const { itemReserveRelease } = useBarometerItemReserveRelease()
  const { carHotbidReset } = useBarometerCarHotbidReset()
  const { auctionTimeChange } = useBarometerAuctionTimeChange()
  const { carFinished } = useBarometerCarFinished()
  const { bidOnAgent } = useBarometerBidOnAgent()

  const init = () => {
    userBid()
    auctionPause()
    auctionResume()
    itemPublish()
    itemWithdrawOrDelete()
    bidOptions()
    bidDeleted()
    carEnterHotbid()
    carInPrepare()
    carNotSold()
    carSold()
    carReserved()
    agentSet()
    itemReserveRelease()
    carHotbidReset()
    auctionTimeChange()
    carFinished()
    bidOnAgent()
  }

  return { init }
}
